module.exports = __webpack_public_path__ + "img/maze_octagonal_g.c983701e.svg";